export function validatePhoneNumber(phone, t) {
  const phoneRegex = /^\+[1-9]\d{7,14}$/;
  if (!phone.length) return null;
  if (!phone.startsWith('+46')) {
    return {
      error: true,
      desc: t('Telefonnumret måste börja med +46'),
    };
  }
  if (phone.startsWith('+460')) {
    return {
      error: true,
      desc: t('Telefonnumret får inte börja med 0 efter landskod'),
    };
  }
  if (!phoneRegex.test(phone)) {
    return {
      error: true,
      desc: t('Telefonnumret är inte giltigt. Exempel: +46701234567'),
    };
  }
  return { error: false };
}
